<script>
  import Icon from "$lib/components/Icon.svelte";
  export let isOpen;

  let clazz = "";
  export { clazz as class };

  const iconClass = "flex-none grow-0";
</script>

<div class={clazz}>
  {#if isOpen}
    <Icon type="chevron-up" class={iconClass} />
    <span class="sr-only">Item Expanded</span>
  {:else}
    <Icon type="chevron-down" class={iconClass} />
    <span class="sr-only">Item Collapsed</span>
  {/if}
</div>
